export enum InputColorType {
  Neutral = 'neutral',
  Dark = 'dark',
  Light = 'light',
}
